export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";